var React = require('react');
const { connect } = require('react-redux');
const { withTranslation } = require('react-i18next');
const { useEffect, useState } = require('react');
var cropDataManager = require('cropDataManager');
var CSS = require('../crop/CropManagement.scss');
const AddNewCropSection = require('AddNewCropSection');
const EditCropSection = require('EditCropSection');
var { trackPageView } = require('Utils');

const CropManagement = (props) => {
  const { t } = props;
  const [crops, setCrops] = useState({});
  const [dataUpdated, setDataUpdated] = useState(true);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ show: false, type: '', message: '' });

  // Show toast notification
  const showToast = (type, message) => {
    setToast({ show: true, type, message });
    setTimeout(() => {
      setToast({ show: false, type: '', message: '' });
    }, 3000);
  };

  useEffect(() => {
    trackPageView('Crop Management');
  }, []);

  useEffect(() => {
    setLoading(true);
    cropDataManager.crop_data().then(
      function (result) {
        setCrops(result.crop_data);
        setLoading(false);
      },
      function (err) {
        console.log(err);
        setLoading(false);
      },
    );
  }, [dataUpdated]);

  const handleDataUpdated = () => {
    setDataUpdated(!dataUpdated);
  };

  return (
    <div className='crop-management-container'>
      {/* Toast Notification */}
      {toast.show && (
        <div className={`crop-toast crop-toast--${toast.type}`}>
          <span className='crop-toast__icon'>
            {toast.type === 'success' ? (
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
                <polyline points='22 4 12 14.01 9 11.01' />
              </svg>
            ) : (
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <circle cx='12' cy='12' r='10' />
                <line x1='15' y1='9' x2='9' y2='15' />
                <line x1='9' y1='9' x2='15' y2='15' />
              </svg>
            )}
          </span>
          <span className='crop-toast__message'>{toast.message}</span>
        </div>
      )}

      <div className='crop-management-header'>
        <h1>{t('crop_management') || 'Crop Management'}</h1>
      </div>

      {loading ? (
        <div className='empty-state'>
          <div
            className='spinner-border text-grey71'
            role='status'
            style={{ width: '2rem', height: '2rem' }}
          >
            <span className='sr-only'>{t('loading')}</span>
          </div>
          <p style={{ marginTop: '12px' }}>{t('loading_crop_data')}</p>
        </div>
      ) : (
        <>
          <AddNewCropSection
            crops={crops}
            onUpdate={() => handleDataUpdated()}
            showToast={showToast}
          />
          <EditCropSection
            crops={crops}
            distributions={props.distributions}
            onUpdate={() => handleDataUpdated()}
            showToast={showToast}
          />
        </>
      )}
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    crop_data: state.crop_data.crop_data,
    distributions: state.distribution_data.distributions,
  };
};

module.exports = connect(mapStateToProps)(withTranslation()(CropManagement));
